// src/components/ModifyCreditLimit.tsx
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

interface ModifyCreditLimitProps {
  distributorName?: string;
  initialCreditLimit?: string;
  onSave?: (creditLimit: string) => void;
}

const EL_ModifyCreditLimit: React.FC<ModifyCreditLimitProps> = ({
  distributorName = '',
  initialCreditLimit = '',
  onSave
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Get parameters from URL if needed
  const searchParams = new URLSearchParams(location.search);
  const urlDistributorName = searchParams.get('distributorName') || distributorName;
  const urlCreditLimit = searchParams.get('creditLimit') || initialCreditLimit;
  const errorMsg = searchParams.get('ErrorMsg') || '';

  // State for credit limit
  const [creditLimit, setCreditLimit] = useState<string>(urlCreditLimit);

  // Show error message if present
  useEffect(() => {
    if (errorMsg) {
      alert(errorMsg);
    }
  }, [errorMsg]);

  // Handle credit limit change with decimal validation
  const handleCreditLimitChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (value === '' || /^[0-9]*\.?[0-9]{0,2}$/.test(value)) {
      setCreditLimit(value);
    }
  };

  // Handle key press for decimal validation
  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const keyCode = e.charCode || e.keyCode;

    // Allow: backspace, delete, tab, escape, enter
    if ([8, 46, 9, 27, 13].includes(keyCode)) {
      return;
    }

    // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
    if (e.ctrlKey && [65, 67, 86, 88].includes(keyCode)) {
      return;
    }

    // Allow: home, end, left, right, up, down
    if ([35, 36, 37, 39, 38, 40].includes(keyCode)) {
      return;
    }

    // Allow only one decimal point
    if (keyCode === 46) { // Decimal point
      if (creditLimit.includes('.')) {
        e.preventDefault();
      }
      return;
    }

    // Allow digits only
    if (keyCode >= 48 && keyCode <= 57) {
      return;
    }

    // Prevent all other characters
    e.preventDefault();
  };

  // Handle save
  const handleSave = () => {
    if (onSave) {
      onSave(creditLimit);
    }
    fn_Update('Y');
    fn_Close();
  };

  // Handle close
  const fn_Close = () => {
    if (window.opener) {
      window.close();
    } else {
      navigate(-1);
    }
  };

  // Function to update return value (migrated from VB)
  const fn_Update = (pUpdate: string) => {
    if (pUpdate === "Y") {
      if (window.opener) {
        window.opener.postMessage({
          type: 'creditLimitUpdated',
          value: creditLimit
        }, '*');
      }
    }
  };

  return (
    <div
      style={{
        height: '280px',
        backgroundImage: "url('/Images/passwordbg.png')",
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        fontFamily: 'Trebuchet MS, sans-serif',
        fontSize: '10pt',
        fontWeight: 'bold',
        textAlign: 'center',
      }}
    >
      <table

        cellPadding="0"
        cellSpacing="0"
        width="100%"
        style={{ marginTop: '50px', textAlign: 'center' }}
      >
        <tbody>
          <tr>
            <td
              style={{
                textAlign: 'center',
                verticalAlign: 'middle',
                width: '380px',
                fontWeight: 'bold',
                paddingBottom: '20px',
                fontFamily: 'Trebuchet MS, sans-serif',
                fontSize: '10pt'
              }}
            >
              {urlDistributorName}
            </td>
          </tr>
          <tr>
            <td
              style={{
                textAlign: 'center',
                verticalAlign: 'middle',
                paddingBottom: '30px',
                fontFamily: 'Trebuchet MS, sans-serif',
                fontSize: '10pt'
              }}
            >
              <b style={{ fontFamily: 'Trebuchet MS, sans-serif', fontSize: '10pt' }}>Credit Limit: </b>&nbsp;
              <input
                type="text"
                id="txtCreditLimit"
                value={creditLimit}
                onChange={handleCreditLimitChange}
                onKeyPress={handleKeyPress}
                maxLength={10}
                style={{
                  fontFamily: 'Trebuchet MS, sans-serif',
                  fontSize: '11pt',
                  border: 'solid 1px #006600',
                  paddingLeft: '5px',
                  width: '100px'
                }}
              />
            </td>
          </tr>
          <tr>
            <td
              style={{
                textAlign: 'center',
                verticalAlign: 'middle',
                fontFamily: 'Trebuchet MS, sans-serif',
                fontSize: '10pt'
              }}
            >
              <button
                type="button"
                onClick={handleSave}
                style={{
                  backgroundImage: "url('/Images/save_n.gif')",
                  backgroundSize: 'contain',
                  backgroundRepeat: 'no-repeat',
                  backgroundColor: '#119ECC',
                  fontFamily: 'Trebuchet MS, sans-serif',
                  fontSize: '8pt',
                  color: 'white',
                  borderStyle: 'none',
                  borderWidth: '0px',
                  height: '20px',
                  width: '80px',
                  cursor: 'pointer',
                  marginRight: '20px'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundImage = "url('/Images/save_o.gif')";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundImage = "url('/Images/save_n.gif')";
                }}
                onMouseDown={(e) => {
                  e.currentTarget.style.backgroundImage = "url('/Images/save_d.gif')";
                }}
              >
                Save
              </button>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <button
                type="button"
                onClick={fn_Close}
                style={{
                  backgroundImage: "url('/Images/cancel_n.gif')",
                  backgroundSize: 'contain',
                  backgroundRepeat: 'no-repeat',
                  backgroundColor: '#119ECC',
                  fontFamily: 'Trebuchet MS, sans-serif',
                  fontSize: '8pt',
                  color: 'white',
                  borderStyle: 'none',
                  borderWidth: '0px',
                  height: '20px',
                  width: '80px',
                  cursor: 'pointer'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundImage = "url('/Images/cancel_o.gif')";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundImage = "url('/Images/cancel_n.gif')";
                }}
                onMouseDown={(e) => {
                  e.currentTarget.style.backgroundImage = "url('/Images/cancel_d.gif')";
                }}
              >
                Cancel
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default EL_ModifyCreditLimit;